const _excluded = ["as", "className", "children", "type", "skin", "underline", "weight", "variant", "prefixIcon", "suffixIcon", "disabled", "intent", "tooltip"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { forwardRef } from 'react';
import cn from 'classnames';
import { ConditionalWrapper } from "../ConditionalWrapper";
import { useIntentBehavior } from "../IntentBehavior";
import { Tooltip } from "../Tooltip";
import typographyStyles from "../Typography/Typography.module.scss";
import styles from "./TextButton.module.scss";
import { TextButtonTestIds } from "./TextButton.utils";

/** Renders a button as text with an underline (styled as a link). */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TextButton = /*#__PURE__*/forwardRef(function TextButton(props, ref) {
  const {
      as,
      className,
      children,
      type,
      skin = 'primary',
      underline = 'always',
      weight = 'light',
      variant = 'paragraph1',
      prefixIcon,
      suffixIcon,
      disabled,
      intent,
      tooltip
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const {
    getDisabled,
    getTooltip
  } = useIntentBehavior();
  const disabledFromIntent = intent ? getDisabled(intent) : false;
  const tooltipFromIntent = intent ? getTooltip(intent) : null;
  const hasTooltip = !!(tooltip !== null && tooltip !== void 0 && tooltip.title) || !!tooltipFromIntent;
  const RootElement = as || 'button';
  const testid = props['data-testid'];
  return /*#__PURE__*/_jsx(ConditionalWrapper, {
    condition: hasTooltip,
    wrapper: children => /*#__PURE__*/_jsx(Tooltip, _objectSpread(_objectSpread({
      "data-testid": TextButtonTestIds.Tooltip(testid)
    }, tooltip || {
      placement: 'top',
      title: tooltipFromIntent
    }), {}, {
      children: /*#__PURE__*/_jsx("div", {
        className: cn(styles.wrapper, className),
        "data-testid": TextButtonTestIds.Wrapper(testid),
        children: children
      })
    })),
    children: /*#__PURE__*/_jsxs(RootElement, _objectSpread(_objectSpread({
      ref: ref,
      type: type || 'button'
    }, rest), {}, {
      disabled: disabledFromIntent || disabled,
      className: cn(styles.root, styles["".concat(skin, "Skin")], styles["".concat(underline, "Underline")], typographyStyles["".concat(weight, "Weight")], typographyStyles["".concat(variant, "Variant")], !hasTooltip && className),
      children: [prefixIcon, /*#__PURE__*/_jsx("span", {
        children: children
      }), suffixIcon]
    }))
  });
});